import DocumentsBlock from './DocumentsBlock';

export default DocumentsBlock;
